import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { Col, Layout, Row } from 'antd'

import { ForgotPasswordValues, saveForgotPasswordValue } from 'core/application/account/forgetPassword'

import notification from 'common/components/feedback/Notification'
import Button from 'common/components/general/Button'

import { commandRequest } from 'common/RequestUtils'

import InstructionsSentLogo from 'assets/images/icons/instructions-sent.svg'

import { ROUTE_PATHS } from '../../common/routePaths'

const InstructionsSent: React.FC = () => {
  const [email, setEmail] = useState<string>('[email]')
  const [loading, setLoading] = useState<boolean>(false)
  const { t: translate } = useTranslation()
  const { emailValue } = useParams<any>()
  let history = useHistory()

  useEffect(() => {
    if (emailValue) {
      setEmail(emailValue)
    }
  }, [emailValue])

  const resendEmail = async (email: string) => {
    setLoading(true)
    let dataForSubmit: ForgotPasswordValues = {
      email,
    }

    let result = await commandRequest(() => saveForgotPasswordValue(dataForSubmit))
    setLoading(false)

    if (result.errors) {
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
      return Promise.reject()
    } else {
      notification.open({
        message: translate('admin-login.email-resend'),
        type: 'success',
      })
    }
  }

  return (
    <Layout>
      <Row justify="center">
        <Col md={12}>
          <Row>
            <Col xs={24} className="mb-8">
              <img src={InstructionsSentLogo} alt="instructions-sent-logo" />
            </Col>
            <Col xs={24}>
              <div>
                <h3>{translate('admin-login.instructions-sent')}</h3>
                <p className="font-16">{translate('admin-login.instructions-sent-msg').replace('[email]', email)}</p>
              </div>
            </Col>
          </Row>
          <br />
          <Row align="middle">
            <Col xs={24} className="mb-4">
              <Button
                onClick={() => resendEmail(email)}
                htmlType="submit"
                type="primary"
                className="w-100"
                loading={loading}
              >
                {translate('admin-login.resend-email-button')}
              </Button>
            </Col>

            <Col xs={12}>
              <a
                onClick={() => {
                  history.push(`${ROUTE_PATHS.FORGOT_PASSWORD_PATH}/${email}`)
                }}
              >
                {translate('admin-login.back-to-forgot-password')}
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default InstructionsSent
